export default __webpack_public_path__ + "static/media/49.37959374.png";